import { Home, Briefcase, FileText, Users, ShieldAlert, Sparkles } from "lucide-react";

export const RAIL_ITEMS = [
  { key: "home", label: "Home", to: "/dashboard", icon: Home, always: true },
  { key: "trattative", label: "Trattative", to: "/trattative", icon: Briefcase },
  { key: "mup", label: "Pratiche MUP", to: "/mup", icon: FileText },
  { key: "anagrafiche", label: "Anagrafiche", to: "/anagrafiche", icon: Users, always: true },
  { key: "sinistri", label: "Sinistri", to: "/gestione-sinistri", icon: ShieldAlert },
  { key: "ai", label: "Assistente AI", to: "/assistente-ai", icon: Sparkles },
];

export const AREE = [
  { key: "operative", short: "Operativa", label: "Area operativa", color: "#1B2380", route: "/dashboard", desc: "MUP, Sinistri e Trattative: il lavoro di ogni giorno." },
  { key: "contabilita_coop", short: "Contabilità", label: "Contabilità Cooperativa", color: "#2A62A0", route: "/contabilita-cooperativa" },
  { key: "strumenti_digitali", short: "Digitale", label: "Strumenti Digitali", color: "#E53935", route: "/strumenti-digitali" },
  { key: "gestione_agenzia", short: "Agenzia", label: "Gestione Agenzia", color: "#F39200", route: "/gestione-agenzia", desc: "Personale, Compliance, Chi fa cosa e Registro Benefit." },
  { key: "direzionale", short: "Direzionale", label: "Direzionale", color: "#F6C400", route: "/direzionale" },
  { key: "benefit", short: "Benefit", label: "Progetti Benefit", color: "#5E9732", route: "/progetti-benefit", desc: "Easy Trasporto, Fabbisogno Formativo e progetti per la comunità." },
];

const KNOWN = AREE.map((a) => a.key).concat("wip");
export const sectionOf = (a) => (KNOWN.includes(a.section || "operative") ? a.section || "operative" : "operative");

export const PUBLIC_PREFIXES = ["/login", "/q/", "/ricevuta/", "/bi-portal", "/sign/", "/sign-form/", "/consenso/", "/mup/appendice/firma/", "/mup/firma/", "/informativa/", "/videochiamata/", "/adesione/", "/area/"];

export const canOpen = (user, apps, to) =>
  user?.role === "admin" || (apps || []).some((a) => a.route && (to === a.route || to.startsWith(`${a.route}/`)));
